import { getDelayAfterPurchase } from '@esentai/core/features/campaigns/purchaseResult/selectors';
import { connect } from 'react-redux';

import Delay from './component';

const mapStateToProps = (state, { itemId }) => ({
  delay: getDelayAfterPurchase(state, itemId),
});

export default connect(mapStateToProps)(Delay);
